import { connect } from 'react-redux';
import {
  getEventNames,
  getMetainf,
  getDashboardsRetentionDimensionType,
  getDashboardsRetentionFirstEvent,
  getDashboardsRetentionReturnEvent,
} from '../../../../../reducers/analyticsApp';
import {
  changeDimensionType,
  changeFirstEvent,
  changeReturnEvent,
} from '../../../../../actions/dashboards/retentionComplex';
import RetentionComposeContainer from '../../../../../components/dashboards/cards/builder/retention/RetentionComposeContainer';

const mapStateToProps = (state, { unitId }) => ({
  events: getEventNames(state),
  dimensionType: getDashboardsRetentionDimensionType(state, unitId),
  firstEvent: getDashboardsRetentionFirstEvent(state, unitId),
  returnEvent: getDashboardsRetentionReturnEvent(state, unitId),
  getEventMetainf: (event) => getMetainf(state, event),
});

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onDimensionTypeChange: (dimensionType) => dispatch(changeDimensionType(unitId, dimensionType)),
  onFirstEventChange: (event, eventMetainf) =>
    dispatch(changeFirstEvent(unitId, event, eventMetainf)),
  onReturnEventChange: (event, eventMetainf) =>
    dispatch(changeReturnEvent(unitId, event, eventMetainf)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetentionComposeContainer);
